import { SelectInputComponent } from './../../../../components/kit/input/select-input/select-input.component';
import { Component, effect, inject, ChangeDetectionStrategy } from '@angular/core';
import { OrganizationYearSelectStore } from './organization-year-select.store';
import { ReactiveFormsModule } from '@angular/forms';
import { fb } from '../../../shared/shared.global-service';
import { toSignal } from '@angular/core/rxjs-interop';
import { ShortDatePipe } from '../../../shared/pipes/short-date.pipe';

@Component({
    selector: 'app-organization-year-select',
    templateUrl: './organization-year-select.component.html',
    styleUrls: ['./organization-year-select.component.scss'],
    providers: [OrganizationYearSelectStore],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        ReactiveFormsModule,
        ShortDatePipe,
        SelectInputComponent,
    ],
})
export class OrganizationYearSelectComponent {
    protected readonly store = inject(OrganizationYearSelectStore);

    public form = fb.group({
        fiscalYear: fb.control<number | null>(null),
    });

    private fiscalYearChange = toSignal(this.form.controls.fiscalYear.valueChanges);
    private oldOrgId = this.store.selectedOrganizationId();
    private organizationChanged = true;

    constructor() {
        // update fiscal year on change
        effect(() => {
            const yearId = this.fiscalYearChange();
            if (!yearId) return;

            this.store.setFiscalYearId(yearId);
        }); // watch for loops, needed to write to global store

        // realize that organization has changed
        effect(() => {
            const orgId = this.store.selectedOrganizationId();
            if (this.oldOrgId == orgId) return; // ignore nothing changed
            // this is to test for change without triggering the items effect
            // as the items are triggering at a later time and not together
            this.organizationChanged = true;
        });

        // allways preselect correct year (first or from previous session)
        // some year has to be selected otherwise the application
        // tries to load data from year possibly not belonging to current organization
        // resulting in "forbidden" errors
        effect(() => {
            // react on items change
            const items = this.store.fiscalYearsScroll().items();

            if (!this.organizationChanged) return; // just a filter without change
            if (!items.length) return; // no items

            // try to find last known fiscal year
            const found = items.find(it => it.id == this.store.globalGlobalStore.organizationStore.selectedFiscalYearId());
            // if not found, preselct first item
            this.form.controls.fiscalYear.setValue(found ? found.id : items[0].id);
            this.organizationChanged = false;
        }); // watch for loops, needed to write to global store
    }
}
